
export async function productScrollInit() {
    const productMenuLinks = document.querySelectorAll('.nav-product-content-wrapper .nav-link');
    const productFixedMenu = document.querySelector('.product-fixed');
    const header = document.querySelector('.scrollmenu');

    /**
     * product scroll to
     */
    if (productMenuLinks.length) {
        let {default: Tab} = await import('bootstrap/js/dist/tab');
        let {getElementFromSelector} = await import("bootstrap/js/src/util");
        productMenuLinks.forEach(productMenuLink => {
            let trigger = new Tab(productMenuLink);
            let target = getElementFromSelector(productMenuLink);
            let productFixedMenuHeight = productFixedMenu.classList.contains('product-fixed--visible') ? productFixedMenu.offsetHeight : 126;
    
            if (target) {
                if (productMenuLink === productMenuLinks[0]) {
                    trigger.show();
                }
            }
    
            productMenuLink.addEventListener('click', evt => {
                evt.preventDefault();
                let currentPosition = window.scrollY;
                let targetScrollPosition;
    
                if (!target) {
                    return;
                }
    
                if (window.matchMedia('(max-width: 768px)').matches) {
                    trigger.show();
                    return;
                }
    
                if (target.offsetTop > currentPosition) {
                    targetScrollPosition = target.offsetTop - productFixedMenuHeight;
                } else {
                    targetScrollPosition = target.offsetTop - productFixedMenuHeight - (header?.offsetHeight || 0);
                }
    
                window.scroll(0, targetScrollPosition);
            });
        });
    }

    /**
     * product nav chevrons
     */
    const productMenuChevronObserver = new window.IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const linkOverClass = 'nav-link-over';
            let target = entry.target;

            productMenuLinks.forEach(link => {
                if (link.getAttribute('href') !== '#' + target.getAttribute('id')) {
                    return;
                }

                if (entry.isIntersecting) {
                    link.classList.add(linkOverClass);
                }

                if (entry.boundingClientRect.top > 0) {
                    link.classList.remove(linkOverClass);
                } else {
                    link.classList.add(linkOverClass);
                }
            });
        });
    }, {
        root: null
    });

    productMenuLinks.forEach(link => {
        let target = document.querySelector(link.getAttribute('href'));
        if (!target) {
            return
        }

        productMenuChevronObserver.observe(target);
    });
}